<div class="files-list" *ngIf="files?.length > 0">
  <div class="details float-start w-100">
    <div class="w-100 d-inline-block">
      <div class="float-start position-relative" *ngFor="let file of files">
        <div *ngIf="file?.isUploading; else filePreview"
          class="common-spinner d-flex flex-column align-items-center justify-content-center py-2 px-3 bg-light rounded">
          <mat-spinner strokeWidth="3" diameter="25"></mat-spinner>
          <h6 class="font-12 mt-1">Loading...</h6>
        </div>
        <ng-template #filePreview>
          <div *ngIf="!isPreviewOnly(file); else previewOnly">
            <div class="attach-img file">
              <div class="image-tools" *ngIf="getType(file.name) == AttachmentFileTypesEnum.Images">
                <button class="m-1" *ngIf="_showImageEditor" (click)="openImageEditorDrawer(file)">
                  <mat-icon class="material-icons-outlined" mat-list-icon>edit
                  </mat-icon>
                </button>
                <button class="m-1" (click)="openDrawer(file)">
                  <mat-icon class="material-icons-outlined" mat-list-icon>visibility
                  </mat-icon>
                </button>
              </div>
              <div *ngIf="file.comment" class="comment-indicator">
                <mat-icon class="material-icons-outlined mat-icon-14" mat-list-icon>comment
                </mat-icon>
              </div>
              <div class="image-tools" *ngIf="getType(file.name) == AttachmentFileTypesEnum.Videos">
                <button class="m-1" (click)="openDrawer(file)">
                  <mat-icon class="material-icons-outlined" mat-list-icon>play_arrow
                  </mat-icon>
                </button>
              </div>
              <div class="image-tools" *ngIf="getType(file.name) == AttachmentFileTypesEnum.Pdf">
                <button class="m-1" (click)="openDrawer(file)">
                  <mat-icon class="material-icons-outlined" mat-list-icon>visibility
                  </mat-icon>
                </button>
              </div>
              <div class="invoice-img-tag" *ngIf="showBeforeAfterTag == true && isImage(file)">
                <span>After</span>
              </div>
              <img *ngIf="getType(file.name) == AttachmentFileTypesEnum.Excel" class="rounded mw-100 cursor-pointer"
                height="52" [src]="previewFile(file)" (click)="download(file.url)" />
              <img *ngIf="
                  getType(file.name) == AttachmentFileTypesEnum.Images ||
                  getType(file.name) == AttachmentFileTypesEnum.Pdf
                " class="rounded mw-100 cursor-pointer" height="52" [src]="previewFile(file)"
                (click)="download(file.url)" />

              <video [src]="file?.url" height="110"
                *ngIf="getType(file.name) == AttachmentFileTypesEnum.Videos"></video>

              <div class="delete-icon cursor-pointer">
                <mat-icon class="material-icons-outlined" mat-list-icon (click)="deleteFile(file)">close</mat-icon>
              </div>
            </div>
          </div>
          <ng-template #previewOnly>
            <div class="attach-img file">
              <div class="image-tools">
                <button class="m-1" (click)="download(file.url)">
                  <mat-icon class="material-icons-outlined" mat-list-icon>cloud_download
                  </mat-icon>
                </button>
              </div>
              <div class="delete-icon cursor-pointer">
                <mat-icon class="material-icons-outlined" mat-list-icon (click)="deleteFile(file)">close</mat-icon>
              </div>
              <div class="invoice-img-tag" *ngIf="showBeforeAfterTag == true &&  isImage(file)">
                <span>After</span>
              </div>
              <img class="rounded mw-100 cursor-pointer" height="52" [src]="previewFile(file)"
                (click)="download(file.url)" />
            </div>
          </ng-template>
        </ng-template>
        <div class="float-start w-100 d-flex align-items-center justify-content-center"
          *ngIf="isScanForAssets && getScannedImageType(file.name) == AttachmentFileTypesEnum.ScannedImages && !file?.isUploading">
          <div class="d-flex align-items-center justify-content-center"
            matTooltip="Once you enable this toggle, the relevant asset will be displayed under the asset register dashboard">
            <mat-label>Asset</mat-label>
            <mat-slide-toggle class="rtl-toggle" [(ngModel)]="file.isScanForAsset"
              (toggleChange)="changeAssetToggle(file)">
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<mat-drawer-container [hasBackdrop]="true" class="custom-drawer">
  <mat-drawer class="xl" mode="over" position="end" [(opened)]="drawerOpened" *ngIf="
      fileToPreview.type == AttachmentFileTypesEnum.Images && isImageEditor
    ">
    <app-image-editor [imgJobId]="jobId" [selectedImage]="{
        blobUrl: fileToPreview.url,
        comment: fileToPreview.comment
      }" (closeEvent)="drawerOpened = false">
    </app-image-editor>
  </mat-drawer>
  <mat-drawer class="lg" mode="over" position="end" [(opened)]="drawerOpened" *ngIf="
      fileToPreview.type == AttachmentFileTypesEnum.Images && !isImageEditor
    ">
    <app-image-viewer [selectedImage]="{
        blobUrl: fileToPreview.url,
        comment: fileToPreview.comment,
        isAfter: fileToPreview.isAfter
      }" [showBeforeAfterTag]="showBeforeAfterTag" (closeEvent)="drawerOpened = false" [isImage]="isImage(fileToPreview)" >
    </app-image-viewer>
  </mat-drawer>
  <mat-drawer class="xl" mode="over" position="end" [(opened)]="drawerOpened"
    *ngIf="fileToPreview.type == AttachmentFileTypesEnum.Pdf">
    <app-pdf-viewer [file]="fileToPreview.url" (closeEvent)="drawerOpened = false"></app-pdf-viewer>
  </mat-drawer>
  <mat-drawer class="lg" mode="over" position="end" [(opened)]="drawerOpened"
    *ngIf="fileToPreview.type == AttachmentFileTypesEnum.Videos">
    <app-video-viewer [file]="fileToPreview.url" (closeEvent)="drawerOpened = false">
    </app-video-viewer>
  </mat-drawer>
</mat-drawer-container>